import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="route-loading">
        <Loader2 className="h-8 w-8 animate-spin text-congo-blue" />
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  if (roles && user.role !== "admin" && !roles.includes(user.role)) {
    return <Navigate to="/tableau-de-bord" replace />;
  }
  return children;
}
